import { createContext } from 'react'

export const breakPointSizeBig = 1300

export interface ForeignPhotoValue {
  baseHrefPhoto: string
  useAuthorizationUrl: boolean
}

/**
 * Нужно использовать контекст, чтобы прокинуть данные из GQL.
 */
export const ForeignPhotoContext = createContext({
  baseHrefPhoto: '',
  useAuthorizationUrl: false,
})
